import React from 'react'

export const documentMap = {
  kinerja: {
    title: 'Hasil Penilaian Kinerja Guru',
    subTitle:
      'Hasil penilaian kinerja dengan sebutan paling rendah Baik selama 2 tahun terakhir untuk setiap unsur penilaian.',
    actionText: 'Lihat contoh dokumen',
    src: `${process.env.NEXT_PUBLIC_BCKS_CDN}/documents/(censored)%20Laporan%20Hasil%20penilaian%20Kinerja%20Guru.pdf`,
  },
  managerial: {
    title: 'Surat Keterangan Pengalaman Manajerial',
    subTitle: (
      <>
        Surat keterangan dari Kepala Sekolah bahwa Anda memiliki pengalaman
        manajerial paling singkat 2 tahun di satuan pendidikan, organisasi
        pendidikan, dan/atau komunitas pendidikan.
        <br /> *Khusus PPPK lampirkan juga bukti pengalaman kerja di dalam 1
        dokumen yang sama
      </>
    ),
    actionText: 'Lihat contoh dokumen',
    src: `${process.env.NEXT_PUBLIC_BCKS_CDN}/documents/(censored)%20KepKepsek%20Penugasan%20Guru%20sebagai%20Kepala%20Perpustakaan.pdf`,
  },
  discipline: {
    title: 'Surat Keterangan Bebas Hukuman Disiplin',
    subTitle:
      'Surat keterangan dari Kepala Sekolah yang diterbitkan dalam 2 tahun terakhir bahwa Anda tidak pernah dikenai hukuman disiplin sedang dan/atau berat sesuai dengan ketentuan peraturan perundang-undangan (tidak perlu meterai).',
    actionText: 'Lihat contoh dokumen',
    src: `${process.env.NEXT_PUBLIC_BCKS_CDN}/documents/(censored)%20Surat%20Pernyataan%20Tidak%20Pernah%20Dijatuhi%20Hukdis.pdf`,
  },
  police: {
    title: 'Surat Keterangan Catatan Kepolisian (masa berlaku 6 bulan)',
    subTitle:
      'Surat keterangan perilaku baik dari Polres setempat yang diterbitkan dalam 6 bulan terakhir bahwa Anda tidak sedang menjadi tersangka, terdakwa, atau tidak pernah menjadi terpidana.',
    actionText: 'Lihat contoh dokumen',
    src: `${process.env.NEXT_PUBLIC_BCKS_CDN}/documents/Surat%20Keterangan%20Catatan%20Kepolisian.pdf`,
  },
  pakta_integritas: {
    title: 'Pakta Integritas',
    subTitle: 'Dokumen perjanjian yang ditandatangani.',
    actionText: 'Lihat contoh dokumen',
    src: `${process.env.NEXT_PUBLIC_BCKS_CDN}/documents/Pakta%20Integritas.pdf`,
  },
}
